<template>
  <div :class="headerwp ? 'wp' : headerbbg ? 'bbg nowp' : 'nowp'">
    <HeaderAll ref="header" />
  </div>
  <router-view ref="page" :key="refreshIdx" />
  <SpinWheelPlacement v-if="route.path === '/'" page="home" />
  <FooterAll v-if="showFooter" />
</template>

<script setup>
import NoticeBox from '@/components/NoticeBox.vue'
import SpinWheelPlacement from '@/components/spin-wheel/SpinWheelPlacement.vue'
import { provide, ref, watch, reactive, onMounted, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useSizeObserver } from '@/utils/SizeUtils'
import Request from '@/services/Request'
import { useUserStore } from '@/stores/UserStore'
import { useFavStore } from '@/stores/FavStore'
const userStore = useUserStore()
const userInfo = userStore.user
const fav = useFavStore()
const router = useRouter()
const route = useRoute()
const showFooter = ref(true)
let headerwp = ref(true)
let headerbbg = ref(true)
const header = ref(null)
const headerSize = useSizeObserver(header, 'innerElement')
let noticeNum = ref(0)
let refreshIdx = ref(0)
let favProducts = ref(null)
let NoticeList = ref(null)
let showNoticeBox = ref(false)
import { useOrderStore } from '@/stores/OrderStore'
const orderStore = useOrderStore()
//import { useOrderStore } from '@/stores/OrderStore';
//const orderStore = useOrderStore()
/* const userInfo = reactive({
  firstName: '',
  lastName: '',
  email: '',
  avater: '',
  customer_id: '',
  phone: '',
  base: ''
})
 */

function loadUserInfo() {
  /*   userInfo.firstName = newUserInfo.firstName
    userInfo.lastName = newUserInfo.lastName
    userInfo.email = newUserInfo.email
    userInfo.avater = newUserInfo.avater
    userInfo.customer_id = newUserInfo.customer_id
    userInfo.phone = newUserInfo.phone; */

  if (1 == 2 && userInfo.customerId) {
    new Request().webGet(
      {},
      (res) => {
        //console.log('loadComment', res)
        noticeNum.value = res.num
      },
      'common/comment/getTotalNum'
    )
  } else {
    //console.log("notdd login")
  }
}

function loadNotice() {
  new Request().webPost(
    {},
    (res) => {
      if (res.success) {
        NoticeList.value = res.data.list
        noticeNum.value = res.data.num + res.data.list['product_inquire'].length
      }
    },
    'common/helpdesk/getLateNotice',
    (err) => {},
    3000,
    2
  )
}

function getFav() {
  new Request().webPost(
    {},
    (res) => {
      if (res.products) {
        favProducts.value = res.products
        if (res.products.length > 0) fav.setCount(res.products.length)
      }
    },
    'account/wishlist'
  )
}
function toFav() {
  if (isLogin()) document.location = '/user/?active=1'
}
function isLogin() {
  if (userInfo.customerId) return true
  else return false
}
function updateShowFooter(value) {
  showFooter.value = value
}
provide('showFooter', { showFooter, updateShowFooter })
// 监听当前路由
watch(
  () => router.currentRoute.value,
  (route) => {
    // console.log('route',route.path)
    if (route.path == '/') {
      headerwp.value = false
      headerbbg.value = true
      window.addEventListener(
        'scroll',
        function () {
          const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
          if (scrollTop > 0) {
            headerbbg.value = false
          } else {
            headerbbg.value = true
          }
        },
        true
      )
    } else {
      headerwp.value = true
      headerbbg.value = false
    }
    switch (route.name) {
      case 'flight':
      case 'booking':
      case 'payment':
      case 'insurance':
        showFooter.value = false
        break
      default:
        break
    }
    // Hide main header on PC for booking-flow pages that have their own booking header
    if (route.name === 'userInsurance') {
      document.body.classList.add('booking-flow-page')
    } else {
      document.body.classList.remove('booking-flow-page')
    }
  },
  { immediate: true }
)

// 监听 userInfo 的变化
watch(
  () => userInfo.customerId,
  (newValue, oldValue) => {
    //console.log('userInfo.customerId changed:', newValue, oldValue);
    //loadNotice()
    // 在这里添加对 customerId 变化的处理逻辑
    const route = router.currentRoute.value
    if (newValue !== oldValue) {
      const needRefreshRoutes = ['membership']
      if (needRefreshRoutes.includes(route.name)) {
        refreshIdx.value++
      }
    }
  }
)
function closeNotice() {
  showNoticeBox.value = false
}

function totop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

onMounted(() => {
  getFav()
})
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .page {
    padding-top: v-bind('headerSize.height + "px"');
  }
}
</style>

<style>
/* PC: hide the main header on booking-flow pages that have their own booking header */
@media screen and (min-width: 751px) {
  body.booking-flow-page .header,
  body.booking-flow-page .header-voyada {
    display: none !important;
  }
}
</style>
